iScreenWizard.factory('Geslacht', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('geslacht', params).then(function (response) {
                var geslachten = response.data;
                resolve(geslachten);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('geslacht/'+id).then(function (response) {
                var geslacht = response.data;
                resolve(geslacht);
            }, reject);
        });
    };

    return data;
});